/** @jsx jsx */
import { Box } from '@bottlebooks/gatsby-design-system';
import { jsx } from 'theme-ui';

export default function Header({
  children,
  isSticky = true,
  isScrolledDown = false,
  showHeader = true,
  homePath,
  locale,
  ...rest
}) {
  return (
    <Box
      as="header"
      sx={{
        display: 'flex',
        variant: 'styles.Header',
        height: [56, 72],
        backgroundColor: 'background',
        borderBottom: '1px solid',
        borderColor: 'border',
        paddingX: [2, 5],
        paddingY: [2, 3],
        ...(isSticky && {
          position: [undefined, 'sticky'],
          zIndex: [undefined, 'header'], // Use the z-index from the theme definition.
          top: [undefined, '0'],
          transition: [undefined, 'transform 0.3s ease-in-out'],
          transform: showHeader ? undefined : [undefined, `translateY(-72px)`],
        }),
        alignItems: 'center',
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}
